import { FileCheck, SlidersHorizontal, ShieldCheck, UserRound, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { useQuote } from "../context/QuoteContext";

const POINTS = [
  {
    icon: FileCheck,
    title: "Duidelijke afspraken",
    text: "Je ontvangt vooraf heldere informatie over de werkzaamheden, planning en kosten.",
  },
  {
    icon: SlidersHorizontal,
    title: "Behandeling op maat",
    text: "We beoordelen de vervuiling en kiezen een passende methode voor het materiaal en de situatie.",
  },
  {
    icon: ShieldCheck,
    title: "Zorgvuldige voorbereiding",
    text: "We beschermen waar nodig de directe omgeving en bereiden iedere behandeling zorgvuldig voor.",
  },
  {
    icon: UserRound,
    title: "Persoonlijk contact",
    text: "Je hebt één duidelijk aanspreekpunt vanaf de aanvraag tot en met de afronding.",
  },
];

export const Reviews = () => {
  const { openQuote } = useQuote();
  return (
    <section
      id="reviews"
      className="relative bg-background py-24 sm:py-32"
      data-testid="reviews"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <SectionLabel>Waarom SoftPro?</SectionLabel>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ink leading-[1.02]">
              Duidelijkheid voor, tijdens en na de reiniging
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              Je wilt vooraf weten wat er wordt uitgevoerd, wat het kost en welk
              resultaat je redelijkerwijs mag verwachten. Daarom werken we met
              persoonlijk advies, een duidelijke offerte en een behandeling die
              wordt afgestemd op de ondergrond.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div
                data-testid={`trust-point-${i}`}
                className="flex h-full flex-col rounded-3xl border border-border bg-card p-7 transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-teal/10 text-teal">
                  <p.icon className="h-6 w-6" strokeWidth={2} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-ink">
                  {p.title}
                </h3>
                <p className="mt-3 flex-1 text-sm text-muted-foreground leading-relaxed">
                  {p.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12">
            <button
              onClick={() => openQuote()}
              data-testid="trust-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-teal px-7 py-4 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Vraag vrijblijvend een offerte aan
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Reviews;
